export default "__VITE_ASSET__C5z7BY5___"